import * as BABYLON from 'babylonjs';
const BJS_VECTOR3 = BABYLON.Vector3;

let CSG3D = {

funcHashXYZ: (x, y, z) => {
    
    return `${x},${y},${z}`;
/*
    // The algorithm below produces incorrect results some of the time:
    x = x >= 0 ? 2 * x : -2 * x - 1;
    y = y >= 0 ? 2 * y : -2 * y - 1;
    z = z >= 0 ? 2 * z : -2 * z - 1;

    let max = Math.max(x, y, z);
    let hash = max*max*max + (2 * max * z) + z;
    if (max == z)
        hash += Math.max(x, y)*Math.max(x, y);
    if (y >= x)
        hash += x + y;
    else
        hash += y;
    return hash;
*/
},


/**
 * Unique ID when we import meshes from Babylon to CSG
 */
currentCSGMeshId: 0,
/**
 * Represents a vertex of a polygon. Use your own vertex class instead of this
 * one to provide additional features like texture coordinates and vertex
 * colors. Custom vertex classes need to provide a `pos` property and `clone()`,
 * `flip()`, and `interpolate()` methods that behave analogous to the ones
 * defined by `BABYLON.CSG.Vertex`. This class provides `normal` so convenience
 * functions like `BABYLON.CSG.sphere()` can return a smooth vertex normal, but `normal`
 * is not used anywhere else.
 * Same goes for uv, it allows to keep the original vertex uv coordinates of the 2 meshes
 */
Vertex: /** @class */ (function () {
    /**
     * Initializes the vertex
     * @param pos The position of the vertex
     * @param normal The normal of the vertex
     * @param uv The texture coordinate of the vertex
     * @param vertColor The RGBA color of the vertex
     */
    function Vertex(
    /**
     * The position of the vertex
     */
    pos, 
    /**
     * The normal of the vertex
     */
    normal, 
    /**
     * The texture coordinate of the vertex
     */
    uv, 
    /**
     * The texture coordinate of the vertex
     */
    vertColor) {
        this.pos = pos;
        this.normal = normal;
        this.uv = uv;
        this.vertColor = vertColor;
    }
    /**
     * Make a clone, or deep copy, of the vertex
     * @returns A new Vertex
     */
    Vertex.prototype.clone = function () {
        let _a, _b;
        return new CSG3D.Vertex(this.pos.clone(), this.normal.clone(), (_a = this.uv) === null || _a === void 0 ? void 0 : _a.clone(), (_b = this.vertColor) === null || _b === void 0 ? void 0 : _b.clone());
    };
    /**
     * Invert all orientation-specific data (e.g. vertex normal). Called when the
     * orientation of a polygon is flipped.
     */
    Vertex.prototype.flip = function () {
        this.normal = this.normal.scale(-1);
    };
    /**
     * Create a new vertex between this vertex and `other` by linearly
     * interpolating all properties using a parameter of `t`. Subclasses should
     * override this to interpolate additional properties.
     * @param other the vertex to interpolate against
     * @param t The factor used to linearly interpolate between the vertices
     */
    Vertex.prototype.interpolate = function (other, t) {
        return new CSG3D.Vertex(BJS_VECTOR3.Lerp(this.pos, other.pos, t), BJS_VECTOR3.Lerp(this.normal, other.normal, t), this.uv && other.uv ? BABYLON.Vector2.Lerp(this.uv, other.uv, t) : undefined, this.vertColor && other.vertColor ? BABYLON.Color4.Lerp(this.vertColor, other.vertColor, t) : undefined);
    };
    return Vertex;
}()),
/**
 * Represents a plane in 3D space.
 */
Plane: /** @class */ (function () {
    /**
     * Initializes the plane
     * @param normal The normal for the plane
     * @param w
     */
    function Plane(normal, w) {
        this.normal = normal;
        this.w = w;
    }
    /**
     * Construct a plane from three points
     * @param a Point a
     * @param b Point b
     * @param c Point c
     */
    Plane.FromPoints = function (a, b, c) {
        let v0 = c.subtract(a);
        let v1 = b.subtract(a);
        if (v0.lengthSquared() === 0 || v1.lengthSquared() === 0) {
            return null;
        }
        let n = BJS_VECTOR3.Normalize(BJS_VECTOR3.Cross(v0, v1));
        return new CSG3D.Plane(n, BJS_VECTOR3.Dot(n, a));
    };
    /**
     * Clone, or make a deep copy of the plane
     * @returns a new Plane
     */
    Plane.prototype.clone = function () {
        return new CSG3D.Plane(this.normal.clone(), this.w);
    };
    /**
     * Flip the face of the plane
     */
    Plane.prototype.flip = function () {
        this.normal.scaleInPlace(-1);
        this.w = -this.w;
    };
    /**
     * Split `polygon` by this plane if needed, then put the polygon or polygon
     * fragments in the appropriate lists. Coplanar polygons go into either
    `* coplanarFront` or `coplanarBack` depending on their orientation with
     * respect to this plane. Polygons in front or in back of this plane go into
     * either `front` or `back`
     * @param polygon The polygon to be split
     * @param coplanarFront Will contain polygons coplanar with the plane that are oriented to the front of the plane
     * @param coplanarBack Will contain polygons coplanar with the plane that are oriented to the back of the plane
     * @param front Will contain the polygons in front of the plane
     * @param back Will contain the polygons begind the plane
     */
    Plane.prototype.splitPolygon = function (polygon, coplanarFront, coplanarBack, front, back, frontNode, backNode) {
        const COPLANAR = 0;
        const FRONT = 1;
        const BACK = 2;
        const SPANNING = 3;
        // Classify each point as well as the entire polygon into one of the above
        // four classes.
        let polygonType = 0;
        let i;
        let t;
        let vert;
        let dotProd;
        let dotProd2;
        for(i = 0; i < polygon.vertices.length; i++)
        {           
            vert = polygon.vertices[i].pos;
            t = (this.normal._x*vert._x + this.normal._y*vert._y + this.normal._z*vert._z) - this.w;
            vert.type = t < -Plane.EPSILON ? BACK : t > Plane.EPSILON ? FRONT : COPLANAR;
            polygonType |= vert.type;           
        }
        // Put the polygon in the correct list, splitting it when necessary
        switch (polygonType) {
            case COPLANAR:
                dotProd = this.normal.x*polygon.plane.normal.x + this.normal.y*polygon.plane.normal.y + this.normal.z*polygon.plane.normal.z;
                let targetArray = (dotProd > 0 ? coplanarFront : coplanarBack);
                polygon.node = (dotProd > 0 ? frontNode : backNode);
                targetArray?.push(polygon);
                break;
            case FRONT:
                polygon.node = frontNode;
                front?.push(polygon);
                break;
            case BACK:
                polygon.node = backNode;
                back?.push(polygon);
                break;
            case SPANNING: {
                let f = [], b = [];
                for (i = 0; i < polygon.vertices.length; i++) {
                    let j = (i + 1) % polygon.vertices.length;
                    let vi = polygon.vertices[i], vj = polygon.vertices[j];
                    let ti = vi.pos.type, tj = vj.pos.type;
                    if (ti !== BACK) {
                        f.push(vi);
                    }
                    if (ti !== FRONT) {
                        b.push(ti !== BACK ? vi.clone() : vi);
                    }
                    if ((ti | tj) === SPANNING) {
                        dotProd = this.normal.x*vi.pos.x + this.normal.y*vi.pos.y + this.normal.z*vi.pos.z;
                        let vecOther = vj.pos.subtract(vi.pos);
                        dotProd2 = this.normal.x*vecOther.x + this.normal.y*vecOther.y + this.normal.z*vecOther.z;
                        t = (this.w - dotProd) / dotProd2;
                        let v = vi.interpolate(vj, t);
                        f.push(v);
                        b.push(v.clone());
                    }
                }
                let poly = void 0;
                if (f.length >= 3 && front) {
                    poly = new CSG3D.Polygon(f, polygon.shared);
                    if (poly.plane) {
                        poly.node = frontNode;
                        front.push(poly);
                    }
                }
                if (b.length >= 3 && back) {
                    poly = new CSG3D.Polygon(b, polygon.shared);
                    if (poly.plane) {
                        poly.node = backNode;
                        back.push(poly);
                    }
                }
                break;
            }
        }
    };
    /**
     * `CSG.Plane.EPSILON` is the tolerance used by `splitPolygon()` to decide if a
     * point is on the plane
     */
    Plane.EPSILON = 1e-5;
    //Plane.EPSILON = 1e-8;
    return Plane;
}()),
/**
 * Represents a convex polygon. The vertices used to initialize a polygon must
 * be coplanar and form a convex loop.
 *
 * Each convex polygon has a `shared` property, which is shared between all
 * polygons that are clones of each other or were split from the same polygon.
 * This can be used to define per-polygon properties (such as surface color)
 */
Polygon: /** @class */ (function () {
    /**
     * Initializes the polygon
     * @param vertices The vertices of the polygon
     * @param shared The properties shared across all polygons
     */
    function Polygon(vertices, shared) {
        this.vertices = vertices;
        this.shared = shared;
        this.plane = CSG3D.Plane.FromPoints(vertices[0].pos, vertices[1].pos, vertices[2].pos);
    }
    /**
     * Clones, or makes a deep copy, or the polygon
     */
    Polygon.prototype.clone = function () {
        let vertices = this.vertices.map(function (v) { return v.clone(); });
        return new CSG3D.Polygon(vertices, this.shared);
    };
    /**
     * Flips the faces of the polygon
     */
    Polygon.prototype.flip = function () {
        // eslint-disable-next-line array-callback-return
        this.vertices.reverse().map(function (v) {
            v.flip();
        });
        this.plane.flip();
    };
    return Polygon;
}()),
/**
 * Holds a node in a BSP tree. A BSP tree is built from a collection of polygons
 * by picking a polygon to split along. That polygon (and all other coplanar
 * polygons) are added directly to that node and the other polygons are added to
 * the front and/or back subtrees. This is not a leafy BSP tree since there is
 * no distinction between internal and leaf nodes
 */
Node: /** @class */ (function () {
    /**
     * Initializes the node
     * @param polygons A collection of polygons held in the node
     */
    function Node(polygons) {
        this._plane = null;
        this._front = null;
        this._back = null;
        this._polygons = new Array();
        if (polygons) {
            this.build(polygons);
        }
    }
    /**
     * Clones, or makes a deep copy, of the node
     * @returns The cloned node
     */
    Node.prototype.clone = function () {
        let node = new CSG3D.Node();
        node._plane = this._plane && this._plane.clone();
        node._front = this._front && this._front.clone();
        node._back = this._back && this._back.clone();
        node._polygons = this._polygons.map(function (p) { return p.clone(); });
        return node;
    };
    /**
     * Convert solid space to empty space and empty space to solid space
     */
    Node.prototype.invert = function () {
        for (let i = 0; i < this._polygons.length; i++) {
            this._polygons[i].flip();
        }
        if (this._plane) {
            this._plane.flip();
        }
        if (this._front) {
            this._front.invert();
        }
        if (this._back) {
            this._back.invert();
        }
        let temp = this._front;
        this._front = this._back;
        this._back = temp;
    };
    /**
     * Recursively remove all polygons in `polygons` that are inside this BSP
     * tree.
     * @param polygons Polygons to remove from the BSP
     * @returns Polygons clipped from the BSP
     */
    Node.prototype.clipPolygons = function (polygonsIn) {

        // Make it a loop instead of being recursive:
        let resPolygons = [];
        let polygonsQueue = polygonsIn;

        for(let poly of polygonsIn)
            poly.node = this;

        for(let queueIndex = 0; queueIndex < polygonsQueue.length; queueIndex++)
		{
            let polygon = polygonsQueue[queueIndex];
            let currNode = polygon.node;

            if(!currNode._plane)
			{
                resPolygons.push(polygon);
                continue;
			}

            let targetFrontArray;
            if(currNode._front)
                targetFrontArray = polygonsQueue;
            else
                targetFrontArray = resPolygons;

            let targetBackArray;
            if(currNode._back)
                targetBackArray = polygonsQueue;
            else
                targetBackArray = null;

            currNode._plane.splitPolygon(polygon, targetFrontArray, targetBackArray, targetFrontArray, targetBackArray, currNode._front, currNode._back);
		}
        return resPolygons;
    };

    Node.prototype.clipPolygonsOLD = function (polygons) {
        if (!this._plane) {
            return polygons.slice();
        }

        let front = new Array(), back = new Array();
        for (let i = 0; i < polygons.length; i++) {
            this._plane.splitPolygon(polygons[i], front, back, front, back);
        }
        if (this._front) {
            front = this._front.clipPolygons(front);
        }
        if (this._back) {
            back = this._back.clipPolygons(back);
        }
        else {
            back = [];
        }
        return front.concat(back);
    };


    /**
     * Remove all polygons in this BSP tree that are inside the other BSP tree
     * `bsp`.
     * @param bsp BSP containing polygons to remove from this BSP
     */
    Node.prototype.clipTo = function (bsp) {
        this._polygons = bsp.clipPolygons(this._polygons);
        if (this._front) {
            this._front.clipTo(bsp);
        }
        if (this._back) {
            this._back.clipTo(bsp);
        }
    };
    /**
     * Return a list of all polygons in this BSP tree
     * @returns List of all polygons in this BSP tree
     */
    Node.prototype.allPolygons = function () {
        let polygons = this._polygons.slice();
        if (this._front) {
            polygons = polygons.concat(this._front.allPolygons());
        }
        if (this._back) {
            polygons = polygons.concat(this._back.allPolygons());
        }
        return polygons;
    };
    /**
     * Build a BSP tree out of `polygons`. When called on an existing tree, the
     * new polygons are filtered down to the bottom of the tree and become new
     * nodes there. Each set of polygons is partitioned using the first polygon
     * (no heuristic is used to pick a good split)
     * @param polygons Polygons used to construct the BSP tree
     */
    Node.prototype.build = function (polygons) {
        if (!polygons.length) {
            return;
        }
        if (!this._plane) {
            this._plane = polygons[0].plane.clone();
        }
        let front = new Array(), back = new Array();
        for (let i = 0; i < polygons.length; i++) {
            this._plane.splitPolygon(polygons[i], this._polygons, this._polygons, front, back);
        }
        if (front.length) {
            if (!this._front) {
                this._front = new CSG3D.Node();
            }
            this._front.build(front);
        }
        if (back.length) {
            if (!this._back) {
                this._back = new CSG3D.Node();
            }
            this._back.build(back);
        }
    };
    return Node;
}()),
/**
 * Class for building Constructive Solid Geometry
 */
CSG: /** @class */ (function () {
    function CSG() {
        this._polygons = new Array();
    }
    /**
     * Convert the Mesh to CSG
     * @param mesh The Mesh to convert to CSG
     * @param absolute If true, the final (local) matrix transformation is set to the identity and not to that of `mesh`. It can help when dealing with right-handed meshes (default: false)
     * @returns A new CSG from the Mesh
     */
    CSG.FromMesh = function (mesh, absolute) {

		if(mesh.isDisposed())
			throw new Error(`Constructing CSG from a disposed mesh: ${mesh.name}`);

        if (absolute === void 0) { absolute = false; }
        let vertex, normal, uv = undefined, position, vertColor = undefined, polygon, vertices;
        let polygons = new Array();
        let matrix, meshPosition, meshRotation, meshRotationQuaternion = null, meshScaling;
        let invertWinding = false;
        if (mesh instanceof BABYLON.Mesh) {
            mesh.computeWorldMatrix(true);
            matrix = mesh.getWorldMatrix();
            meshPosition = mesh.position.clone();
            meshRotation = mesh.rotation.clone();
            if (mesh.rotationQuaternion) {
                meshRotationQuaternion = mesh.rotationQuaternion.clone();
            }
            meshScaling = mesh.scaling.clone();
            if (mesh.material && absolute) {
                invertWinding = mesh.material.sideOrientation === BABYLON.Constants.MATERIAL_ClockWiseSideOrientation;
            }
        }
        else {
            throw(new Error("BABYLON.CSG: Wrong Mesh type, must be BABYLON.Mesh"));
        }
        let indices = mesh.getIndices(), positions = mesh.getVerticesData(BABYLON.VertexBuffer.PositionKind), normals = mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind), uvs = mesh.getVerticesData(BABYLON.VertexBuffer.UVKind), vertColors = mesh.getVerticesData(BABYLON.VertexBuffer.ColorKind);
        let subMeshes = mesh.subMeshes ? mesh.subMeshes : [];
        for (let sm = 0, sml = subMeshes.length; sm < sml; sm++) {
            for (let i = subMeshes[sm].indexStart, il = subMeshes[sm].indexCount + subMeshes[sm].indexStart; i < il; i += 3) {
                vertices = [];
                for (let j = 0; j < 3; j++) {
                    let indexIndices = j === 0 ? i + j : invertWinding ? i + 3 - j : i + j;
                    let sourceNormal = new BJS_VECTOR3(normals[indices[indexIndices] * 3], normals[indices[indexIndices] * 3 + 1], normals[indices[indexIndices] * 3 + 2]);
                    if (uvs) {
                        uv = new BABYLON.Vector2(uvs[indices[indexIndices] * 2], uvs[indices[indexIndices] * 2 + 1]);
                    }
                    if (vertColors) {
                        vertColor = new BABYLON.Color4(vertColors[indices[indexIndices] * 4], vertColors[indices[indexIndices] * 4 + 1], vertColors[indices[indexIndices] * 4 + 2], vertColors[indices[indexIndices] * 4 + 3]);
                    }
                    let sourcePosition = new BJS_VECTOR3(positions[indices[indexIndices] * 3], positions[indices[indexIndices] * 3 + 1], positions[indices[indexIndices] * 3 + 2]);
                    position = BJS_VECTOR3.TransformCoordinates(sourcePosition, matrix);
                    normal = BJS_VECTOR3.TransformNormal(sourceNormal, matrix);
                    vertex = new CSG3D.Vertex(position, normal, uv, vertColor);
                    vertices.push(vertex);
                }
                polygon = new CSG3D.Polygon(vertices, { subMeshId: sm, meshId: CSG3D.currentCSGMeshId, materialIndex: subMeshes[sm].materialIndex });
                // To handle the case of degenerated triangle
                // polygon.plane == null <=> the polygon does not represent 1 single plane <=> the triangle is degenerated
                if (polygon.plane) {
                    polygons.push(polygon);
                }
            }
        }
        let csg = CSG._FromPolygons(polygons);
        csg.matrix = absolute ? BABYLON.Matrix.Identity() : matrix;
        csg.position = absolute ? BJS_VECTOR3.Zero() : meshPosition;
        csg.rotation = absolute ? BJS_VECTOR3.Zero() : meshRotation;
        csg.scaling = absolute ? BJS_VECTOR3.One() : meshScaling;
        csg.rotationQuaternion = absolute && meshRotationQuaternion ? BABYLON.Quaternion.Identity() : meshRotationQuaternion;
        CSG3D.currentCSGMeshId++;
        return csg;
    };
    /**
     * Construct a CSG solid from a list of `CSG.Polygon` instances.
     * @param polygons Polygons used to construct a CSG solid
     */
    CSG._FromPolygons = function (polygons) {
        let csg = new CSG3D.CSG();
        csg._polygons = polygons;
        return csg;
    };
    /**
     * Clones, or makes a deep copy, of the CSG
     * @returns A new CSG
     */
    CSG.prototype.clone = function () {
        let csg = new CSG3D.CSG();
        csg._polygons = [];
        for(let poly of this._polygons)
            csg._polygons.push(poly.clone());
        csg.copyTransformAttributes(this);
        return csg;
    };
    /**
     * Unions this CSG with another CSG
     * @param csg The CSG to union against this CSG
     * @returns The unioned CSG
     */
    CSG.prototype.union = function (csg) {
        let a = new CSG3D.Node(this.clone()._polygons);
        let b = new CSG3D.Node(csg.clone()._polygons);
        a.clipTo(b);
        b.clipTo(a);
        b.invert();
        b.clipTo(a);
        b.invert();
        a.build(b.allPolygons());
        return CSG._FromPolygons(a.allPolygons()).copyTransformAttributes(this);
    };
    /**
     * Unions this CSG with another CSG in place
     * @param csg The CSG to union against this CSG
     */
    CSG.prototype.unionInPlace = function (csg) {
        let a = new CSG3D.Node(this._polygons);
        let b = new CSG3D.Node(csg._polygons);
        a.clipTo(b);
        b.clipTo(a);
        b.invert();
        b.clipTo(a);
        b.invert();
        a.build(b.allPolygons());
        this._polygons = a.allPolygons();
    };

    CSG.prototype.xor = function (csg) {
        let a = new CSG3D.Node(this.clone()._polygons);
        let b = new CSG3D.Node(csg.clone()._polygons);

        let a2 = new CSG3D.Node(this.clone()._polygons);
        let b2 = new CSG3D.Node(csg.clone()._polygons);

        a.invert();
        b.clipTo(a);
        b.invert();
        a.clipTo(b);
        b.clipTo(a);
        a.build(b.allPolygons());
        a.invert();

        let invIntersection = a;
        let invIntersection2 = a.clone();
        
        a2.invert();
        a2.clipTo(invIntersection);
        invIntersection.clipTo(a2);
        invIntersection.invert();
        invIntersection.clipTo(a2);
        invIntersection.invert();
        a2.build(invIntersection.allPolygons());
        a2.invert();
        /**/
        b2.invert();
        b2.clipTo(invIntersection2);
        invIntersection2.clipTo(b2);
        invIntersection2.invert();
        invIntersection2.clipTo(b2);
        invIntersection2.invert();
        b2.build(invIntersection2.allPolygons());
        b2.invert();

        a2.clipTo(b2);
        b2.clipTo(a2);
        b2.invert();
        b2.clipTo(a2);
        b2.invert();
        a2.build(b2.allPolygons());


a=a2;
        //a.clipTo(b);
        //b.clipTo(a);
        //b.invert();
        //b.clipTo(a);
        //b.invert();
        //a.build(b.allPolygons());
        /*
        let a2 = new CSG3D.Node(this.clone()._polygons);

        b.invert();
        a.clipTo(b);
        b.invert();

        a2.invert();
        b.clipTo(a2);
        a2.invert();

        a.build(b.allPolygons());
        */

        /*
        a.invert();
        b.clipTo(a);
        b.invert();
        a.clipTo(b);
        b.clipTo(a);
        a.build(b.allPolygons());
        a.invert();
        let intersectionCSG = a;

        a = new CSG3D.Node(this.clone()._polygons);
        b = new CSG3D.Node(intersectionCSG.clone()._polygons);
        a.invert();
        a.clipTo(b);
        b.clipTo(a);
        b.invert();
        b.clipTo(a);
        b.invert();
        a.build(b.allPolygons());
        a.invert();
        */

        return CSG._FromPolygons(a.allPolygons()).copyTransformAttributes(this);
    };
    /**
     * Subtracts this CSG with another CSG
     * @param csg The CSG to subtract against this CSG
     * @returns A new CSG
     */
    CSG.prototype.subtract = function (csg) {
        let a = new CSG3D.Node(this.clone()._polygons);
        let b = new CSG3D.Node(csg.clone()._polygons);
        a.invert();
        a.clipTo(b);
        b.clipTo(a);
        b.invert();
        b.clipTo(a);
        b.invert();
        a.build(b.allPolygons());
        a.invert();
        return CSG._FromPolygons(a.allPolygons()).copyTransformAttributes(this);
    };
    /**
     * Subtracts this CSG with another CSG in place
     * @param csg The CSG to subtract against this CSG
     */
    CSG.prototype.subtractInPlace = function (csg) {
        let a = new CSG3D.Node(this._polygons);
        let b = new CSG3D.Node(csg._polygons);
        a.invert();
        a.clipTo(b);
        b.clipTo(a);
        b.invert();
        b.clipTo(a);
        b.invert();
        a.build(b.allPolygons());
        a.invert();
        this._polygons = a.allPolygons();
    };
    /**
     * Intersect this CSG with another CSG
     * @param csg The CSG to intersect against this CSG
     * @returns A new CSG
     */
    CSG.prototype.intersect = function (csg) {
        let a = new CSG3D.Node(this.clone()._polygons);
        let b = new CSG3D.Node(csg.clone()._polygons);
        a.invert();
        b.clipTo(a);
        b.invert();
        a.clipTo(b);
        b.clipTo(a);
        a.build(b.allPolygons());
        a.invert();
        return CSG._FromPolygons(a.allPolygons()).copyTransformAttributes(this);
    };
    /**
     * Intersects this CSG with another CSG in place
     * @param csg The CSG to intersect against this CSG
     */
    CSG.prototype.intersectInPlace = function (csg) {
        let a = new CSG3D.Node(this._polygons);
        let b = new CSG3D.Node(csg._polygons);
        a.invert();
        b.clipTo(a);
        b.invert();
        a.clipTo(b);
        b.clipTo(a);
        a.build(b.allPolygons());
        a.invert();
        this._polygons = a.allPolygons();
    };
    /**
     * Return a new CSG solid with solid and empty space switched. This solid is
     * not modified.
     * @returns A new CSG solid with solid and empty space switched
     */
    CSG.prototype.inverse = function () {
        let csg = this.clone();
        csg.inverseInPlace();
        return csg;
    };
    /**
     * Inverses the CSG in place
     */
    CSG.prototype.inverseInPlace = function () {
        // eslint-disable-next-line array-callback-return
        this._polygons.map(function (p) {
            p.flip();
        });
    };
    /**
     * This is used to keep meshes transformations so they can be restored
     * when we build back a Babylon Mesh
     * NB : All CSG operations are performed in world coordinates
     * @param csg The CSG to copy the transform attributes from
     * @returns This CSG
     */
    CSG.prototype.copyTransformAttributes = function (csg) {
        this.matrix = csg.matrix;
        this.position = csg.position;
        this.rotation = csg.rotation;
        this.scaling = csg.scaling;
        this.rotationQuaternion = csg.rotationQuaternion;
        return this;
    };
    /**
     * Build Raw mesh from CSG
     * Coordinates here are in world space
     * @param name The name of the mesh geometry
     * @param scene The Scene
     * @param keepSubMeshes Specifies if the submeshes should be kept
     * @returns A new Mesh
     */
    CSG.prototype.buildMeshGeometry = function (name, scene, keepSubMeshes) {
        let matrix = this.matrix.clone();
        matrix.invert();
        let mesh = new BABYLON.Mesh(name, scene);
        let vertices = [];
        let indices = [];
        let normals = [];
        let uvs = null;
        let vertColors = null;
        let vertex = BJS_VECTOR3.Zero();
        let normal = BJS_VECTOR3.Zero();
        let uv = BABYLON.Vector2.Zero();
        let vertColor = new BABYLON.Color4(0, 0, 0, 0);
        let polygons = this._polygons ? this._polygons : this.polygons;
        let polygonIndices = [0, 0, 0];
        let polygon;
        let vertice_dict = new Map();

        let localNormal = BJS_VECTOR3.Zero();
        let localVertex = BJS_VECTOR3.Zero();
        let localVertexKey;

        let vertex_idx;
        let currentIndex = 0;
        let subMeshDict = {};
        let subMeshObj;
        if (keepSubMeshes) {
            // Sort Polygons, since subMeshes are indices range
            polygons.sort(function (a, b) {
                if (a.shared.meshId === b.shared.meshId) {
                    return a.shared.subMeshId - b.shared.subMeshId;
                }
                else {
                    return a.shared.meshId - b.shared.meshId;
                }
            });
        }
        for (let i = 0, il = polygons.length; i < il; i++) {
            polygon = polygons[i];

            // We skip zero-area polygons, since they create errors in USD
            // conversion, in particular, and are useless in general.
            if(polygon.vertices[0].normal.lengthSquared() < 1e-14
             && polygon.vertices[1].normal.lengthSquared() < 1e-14
             && polygon.vertices[2].normal.lengthSquared() < 1e-14)
                continue;

            // Building SubMeshes
            if (!subMeshDict[polygon.shared.meshId]) {
                subMeshDict[polygon.shared.meshId] = {};
            }
            if (!subMeshDict[polygon.shared.meshId][polygon.shared.subMeshId]) {
                subMeshDict[polygon.shared.meshId][polygon.shared.subMeshId] = {
                    indexStart: +Infinity,
                    indexEnd: -Infinity,
                    materialIndex: polygon.shared.materialIndex,
                };
            }
            subMeshObj = subMeshDict[polygon.shared.meshId][polygon.shared.subMeshId];
            for (let j = 2, jl = polygon.vertices.length; j < jl; j++) {
                polygonIndices[0] = 0;
                polygonIndices[1] = j - 1;
                polygonIndices[2] = j;
                for (let k = 0; k < 3; k++) {
                    vertex.copyFrom(polygon.vertices[polygonIndices[k]].pos);
                    normal.copyFrom(polygon.vertices[polygonIndices[k]].normal);
                    if (polygon.vertices[polygonIndices[k]].uv) {
                        if (!uvs) {
                            uvs = [];
                        }
                        uv.copyFrom(polygon.vertices[polygonIndices[k]].uv);
                    }
                    if (polygon.vertices[polygonIndices[k]].vertColor) {
                        if (!vertColors) {
                            vertColors = [];
                        }
                        vertColor.copyFrom(polygon.vertices[polygonIndices[k]].vertColor);
                    }
                    BJS_VECTOR3.TransformCoordinatesToRef(vertex, matrix, localVertex);
                    BJS_VECTOR3.TransformNormalToRef(normal, matrix, localNormal);

                    //localVertexKey = localVertex.x + "," + localVertex.y + "," + localVertex.z;
                    localVertexKey = CSG3D.funcHashXYZ(localVertex.x, localVertex.y, localVertex.z);
                    vertex_idx = vertice_dict.get(localVertexKey);

                    let areUvsDifferent = false;
                    if (uvs && !(uvs[vertex_idx * 2] === uv.x || uvs[vertex_idx * 2 + 1] === uv.y)) {
                        areUvsDifferent = true;
                    }
                    let areColorsDifferent = false;
                    if (vertColors &&
                        !(vertColors[vertex_idx * 4] === vertColor.r ||
                            vertColors[vertex_idx * 4 + 1] === vertColor.g ||
                            vertColors[vertex_idx * 4 + 2] === vertColor.b ||
                            vertColors[vertex_idx * 4 + 3] === vertColor.a)) {
                        areColorsDifferent = true;
                    }
                    // Check if 2 points can be merged
                    //if (!(typeof vertex_idx !== "undefined" &&
                    if (!(vertex_idx !== undefined &&
                        normals[vertex_idx * 3] === localNormal.x &&
                        normals[vertex_idx * 3 + 1] === localNormal.y &&
                        normals[vertex_idx * 3 + 2] === localNormal.z) ||
                        areUvsDifferent ||
                        areColorsDifferent) {
                        vertices.push(localVertex.x, localVertex.y, localVertex.z);
                        if (uvs) {
                            uvs.push(uv.x, uv.y);
                        }
                        ///normals.push(normal.x, normal.y, normal.z);
                        normals.push(localNormal.x, localNormal.y, localNormal.z);
                        if (vertColors) {
                            vertColors.push(vertColor.r, vertColor.g, vertColor.b, vertColor.a);
                        }
                        vertex_idx = vertices.length / 3 - 1;
                        vertice_dict.set(localVertexKey, vertex_idx);
                        //vertex_idx = vertice_dict[localVertexKey] = vertices.length / 3 - 1;
                    }
                    indices.push(vertex_idx);
                    subMeshObj.indexStart = Math.min(currentIndex, subMeshObj.indexStart);
                    subMeshObj.indexEnd = Math.max(currentIndex, subMeshObj.indexEnd);
                    currentIndex++;
                }
            }
        }

        if(vertices.length > 0)
		{
            mesh.setVerticesData(BABYLON.VertexBuffer.PositionKind, vertices);
            mesh.setVerticesData(BABYLON.VertexBuffer.NormalKind, normals);
		}
        if (uvs) {
            mesh.setVerticesData(BABYLON.VertexBuffer.UVKind, uvs);
        }
        if (vertColors) {
            mesh.setVerticesData(BABYLON.VertexBuffer.ColorKind, vertColors);
        }

        if(indices.length > 0)
            mesh.setIndices(indices, null);

        if (keepSubMeshes) {
            // We offset the materialIndex by the previous number of materials in the CSG mixed meshes
            let materialIndexOffset = 0, materialMaxIndex = void 0;
            mesh.subMeshes = new Array();
            for (let m in subMeshDict) {
                materialMaxIndex = -1;
                for (let sm in subMeshDict[m]) {
                    subMeshObj = subMeshDict[m][sm];
                    BABYLON.SubMesh.CreateFromIndices(subMeshObj.materialIndex + materialIndexOffset, subMeshObj.indexStart, subMeshObj.indexEnd - subMeshObj.indexStart + 1, mesh);
                    materialMaxIndex = Math.max(subMeshObj.materialIndex, materialMaxIndex);
                }
                materialIndexOffset += ++materialMaxIndex;
            }
        }
        return mesh;
    };

    CSG.prototype.dispose = function () {
        // Nothing, just for compatibility with C++ based CSG.
    };

    /**
     * Build Mesh from CSG taking material and transforms into account
     * @param name The name of the Mesh
     * @param material The material of the Mesh
     * @param scene The Scene
     * @param keepSubMeshes Specifies if submeshes should be kept
     * @returns The new Mesh
     */
    CSG.prototype.toMesh = function (name, material, scene, keepSubMeshes) {
        if (material === void 0) { material = null; }
        let mesh = this.buildMeshGeometry(name, scene, keepSubMeshes);
        mesh.material = material;
        mesh.position.copyFrom(this.position);
        mesh.rotation.copyFrom(this.rotation);
        if (this.rotationQuaternion) {
            mesh.rotationQuaternion = this.rotationQuaternion.clone();
        }
        mesh.scaling.copyFrom(this.scaling);
        mesh.computeWorldMatrix(true);
        return mesh;
    };
    return CSG;
}())

};

export default CSG3D;
